import { Box, Typography } from '@mui/material';

type ItemDescriptionProps = {
  description: string[];
};

export function ItemDescription({ description }: ItemDescriptionProps) {
  return (
    <>
      {description?.length > 0 && (
        <Box
          sx={{
            mt: '15px',
            ml: '35px',
            mr: '5px',
            px: '5px',
            fontStyle: 'italic',
            color: 'error.main',
          }}
        >
          {description.map((desc, index) => (
            <Typography sx={{ fontSize: '16px' }} key={index}>
              {desc}
            </Typography>
          ))}
        </Box>
      )}
    </>
  );
}
